__turbopack_context__.v({
  "activeTabFaq": "FaqUIWithoutCategory-module-scss-module__pGA_dW__activeTabFaq",
  "answerCollapse": "FaqUIWithoutCategory-module-scss-module__pGA_dW__answerCollapse",
  "answerCollapseInner": "FaqUIWithoutCategory-module-scss-module__pGA_dW__answerCollapseInner",
  "answerOpen": "FaqUIWithoutCategory-module-scss-module__pGA_dW__answerOpen",
  "backChange": "FaqUIWithoutCategory-module-scss-module__pGA_dW__backChange",
  "deactiveTabFaq": "FaqUIWithoutCategory-module-scss-module__pGA_dW__deactiveTabFaq",
  "faqAns": "FaqUIWithoutCategory-module-scss-module__pGA_dW__faqAns",
  "faqAnsCk": "FaqUIWithoutCategory-module-scss-module__pGA_dW__faqAnsCk",
  "faqItem": "FaqUIWithoutCategory-module-scss-module__pGA_dW__faqItem",
  "faqItemOpen": "FaqUIWithoutCategory-module-scss-module__pGA_dW__faqItemOpen",
  "faqQue": "FaqUIWithoutCategory-module-scss-module__pGA_dW__faqQue",
  "faqQues": "FaqUIWithoutCategory-module-scss-module__pGA_dW__faqQues",
  "faqQuesHeading": "FaqUIWithoutCategory-module-scss-module__pGA_dW__faqQuesHeading",
  "faqTabFadeIn": "FaqUIWithoutCategory-module-scss-module__pGA_dW__faqTabFadeIn",
  "faqblock": "FaqUIWithoutCategory-module-scss-module__pGA_dW__faqblock",
  "faqtab": "FaqUIWithoutCategory-module-scss-module__pGA_dW__faqtab",
  "faqtabQes": "FaqUIWithoutCategory-module-scss-module__pGA_dW__faqtabQes",
  "homeHeadingFaq": "FaqUIWithoutCategory-module-scss-module__pGA_dW__homeHeadingFaq",
  "icon": "FaqUIWithoutCategory-module-scss-module__pGA_dW__icon",
  "jobRoleAns": "FaqUIWithoutCategory-module-scss-module__pGA_dW__jobRoleAns",
  "jobRoleBlock": "FaqUIWithoutCategory-module-scss-module__pGA_dW__jobRoleBlock",
  "jobRoleHeading": "FaqUIWithoutCategory-module-scss-module__pGA_dW__jobRoleHeading",
  "jobRoleQue": "FaqUIWithoutCategory-module-scss-module__pGA_dW__jobRoleQue",
  "leadTheFutureContainerInner": "FaqUIWithoutCategory-module-scss-module__pGA_dW__leadTheFutureContainerInner",
  "mainHeadingFaq": "FaqUIWithoutCategory-module-scss-module__pGA_dW__mainHeadingFaq",
  "tabBtnFaq": "FaqUIWithoutCategory-module-scss-module__pGA_dW__tabBtnFaq",
  "tabPanel": "FaqUIWithoutCategory-module-scss-module__pGA_dW__tabPanel",
});
